import { css } from '@/styled-system/css';

export const overlayContainer = css({
  pointerEvents: 'auto',
  position: 'absolute',
  zIndex: 'zIndexStep',
  visibility: 'hidden',
  // draw() sets the placement attribute only once it has real dimensions to
  // measure against, so it doubles as the "safe to show" flag.
  '&[data-map-overlay-placement]': {
    visibility: 'visible',
  },
});
